"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderRadioGroup = exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _formik = require("formik");
var _Theme = _interopRequireDefault(require("../Theme"));
var _RadioGroup = _interopRequireDefault(require("../RadioGroup"));
var _CardInfo = _interopRequireDefault(require("../CardInfo"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _Text = _interopRequireDefault(require("../Text"));
var _constant = require("../constant");
var _GuestPersonalInfo = require("../GuestPersonalInfo");
var _GuestOfwInfo = require("../GuestOfwInfo");
var _constant2 = require("./constant");
var _GuestPwdInfo = _interopRequireDefault(require("./GuestPwdInfo.proptypes"));
var _excluded = ["form", "handleField"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "GuestPwdInfo__StyledContainer",
  componentId: "sc-w6y6qi-0"
})([""]);
var renderRadioGroup = function renderRadioGroup(fieldProps) {
  var form = fieldProps.form,
    handleField = fieldProps.handleField,
    rest = (0, _objectWithoutProperties2.default)(fieldProps, _excluded);
  var errors = form.errors;
  var field = rest.field.name;
  return /*#__PURE__*/_react.default.createElement(_RadioGroup.default, (0, _extends2.default)({}, rest, {
    onChange: function onChange(e) {
      if (e.value === 'true') {
        form.errors = {};
        form.setFieldTouched(_constant2.FIELDS.pwdId.name, false, false);
        form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, e.value)));
      } else {
        var _objectSpread3;
        form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (_objectSpread3 = {}, (0, _defineProperty2.default)(_objectSpread3, _constant2.FIELDS.pwdId.name, null), (0, _defineProperty2.default)(_objectSpread3, field, e.value), _objectSpread3)));
      }
      handleField((0, _defineProperty2.default)({}, field, e.value));
      form.setFieldTouched(field, true, false);
    },
    validateMessage: errors[field] || ''
  }, form.touched[field] && {
    validateStatus: errors[field] ? 'error' : 'success'
  }));
};
exports.renderRadioGroup = renderRadioGroup;
var GuestPwdInfo = function GuestPwdInfo(_ref) {
  var accessible = _ref.accessible,
    theme = _ref.theme,
    customProperties = _ref.customProperties,
    initialValues = _ref.initialValues,
    onSubmit = _ref.onSubmit,
    formRef = _ref.formRef,
    translation = _ref.translation,
    handleField = _ref.handleField,
    maxCharLengthAllowed = _ref.maxCharLengthAllowed,
    gtmLabel = _ref.gtmLabel,
    fireGtm = _ref.fireGtm,
    pwdIdMaxChar = _ref.pwdIdMaxChar,
    newVersion = _ref.newVersion,
    useDocRules = _ref.useDocRules,
    data = _ref.data,
    allowSpace = _ref.allowSpace;
  var innerWidth = function innerWidth() {
    return typeof window !== 'undefined' ? window.innerWidth : 300;
  };
  var _React$useState = _react.default.useState(innerWidth()),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    windowWidth = _React$useState2[0],
    setWindowWidth = _React$useState2[1];
  var _React$useState3 = _react.default.useState((0, _GuestOfwInfo.getValidator)(maxCharLengthAllowed, pwdIdMaxChar, allowSpace)),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    fieldValidation = _React$useState4[0],
    setFieldValidation = _React$useState4[1];
  var _React$useState5 = _react.default.useState([]),
    _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
    errorList = _React$useState6[0],
    setErrorList = _React$useState6[1];
  var _React$useState7 = _react.default.useState(false),
    _React$useState8 = (0, _slicedToArray2.default)(_React$useState7, 2),
    showModal = _React$useState8[0],
    setShowModal = _React$useState8[1];
  /* istanbul ignore next */
  _react.default.useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', function () {
        return setWindowWidth(innerWidth());
      });
    }
    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', function () {
          return setWindowWidth(innerWidth());
        });
      }
    };
  }, []);
  _react.default.useEffect(function () {
    setFieldValidation((0, _GuestOfwInfo.getValidator)(maxCharLengthAllowed, pwdIdMaxChar, allowSpace));
  }, [maxCharLengthAllowed, pwdIdMaxChar, allowSpace]);
  var isMobile = windowWidth <= parseInt(_constant.BREAKPOINTS.MOBILE.replace('px', ''), 10);
  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATION), translation);
  var isFullWidth = isMobile || useDocRules;
  _react.default.useEffect(function () {
    if (errorList.length > 0) {
      (0, _GuestPersonalInfo.createErrorGtmObject)(errorList, gtmLabel, fireGtm);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorList]);
  var errorCallback = function errorCallback(field, add) {
    if (add) {
      var newList = errorList.filter(function (val) {
        return val === field;
      });
      if (newList.length <= 0) {
        setErrorList([].concat((0, _toConsumableArray2.default)(errorList), [field]));
      }
    } else {
      var _newList = errorList.filter(function (val) {
        return val !== field;
      });
      setErrorList((0, _toConsumableArray2.default)(_newList));
    }
  };
  var closeModal = function closeModal() {
    setShowModal(false);
  };
  var displayModal = function displayModal(title, message) {
    return /*#__PURE__*/_react.default.createElement(_Modal.default, {
      openModal: showModal,
      theme: theme,
      title: title,
      onClose: closeModal
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme,
      type: _constant2.TEXT.TYPE
    }, message));
  };
  var returnToolTipContainer = function returnToolTipContainer(message) {
    return isMobile ? /*#__PURE__*/_react.default.createElement(_GuestOfwInfo.ToolTipContainer, {
      isMobile: isMobile,
      onClick: function onClick() {
        setShowModal(true);
      }
    }, (0, _GuestOfwInfo.returnToolTipIcon)(theme, accessible)) : (0, _GuestOfwInfo.returnToolTipContent)(theme, accessible, isMobile, message);
  };
  var returnContent = function returnContent(title, message) {
    return /*#__PURE__*/_react.default.createElement(_GuestOfwInfo.TitleContainer, {
      isMobile: isMobile
    }, (0, _GuestOfwInfo.returnText)(title, theme), newVersion && returnToolTipContainer(message));
  };
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledContainer, (0, _extends2.default)({}, customProperties, {
    tabIndex: !accessible ? '-1' : '0'
  }), /*#__PURE__*/_react.default.createElement(_formik.Formik, (0, _extends2.default)({
    innerRef: formRef,
    initialValues: initialValues,
    onSubmit: onSubmit,
    enableReinitialize: true
  }, customProperties, {
    data: data
  }), function (props) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      _react.default.createElement("form", {
        onSubmit: props.handleSubmit,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter') {
            props.handleSubmit();
          }
        }
      }, /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.Container, null, /*#__PURE__*/_react.default.createElement(_GuestOfwInfo.ExpandingFieldGroup, {
        isFullWidth: isFullWidth
      }, /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
        width: isFullWidth ? 100 : 50
      }, returnContent(language.registeredPwd, language.pwdNote), showModal && displayModal(language.pwdNoteHeader, language.pwdNote), /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: renderRadioGroup,
        accessible: accessible,
        color: _constant2.TEXT.COLOR,
        handleField: handleField,
        isFullWidth: false,
        isMobile: isMobile,
        isReversed: false,
        name: _constant2.FIELDS.isPwd.name,
        options: _constant2.IS_DISABLED_OPTIONS,
        selectedId: "",
        theme: theme,
        value: props.values[_constant2.FIELDS.isPwd.name] || 'false',
        vertical: false
      })), props.values[_constant2.FIELDS.isPwd.name] === 'true' && /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
        width: isFullWidth ? 100 : 50
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: _GuestPersonalInfo.renderField,
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.pwdId || _constant2.FIELDS.pwdId.label,
        name: _constant2.FIELDS.pwdId.name,
        theme: theme,
        handleField: handleField,
        value: props.values[_constant2.FIELDS.pwdId.name],
        validate: function validate(val) {
          return (0, _GuestPersonalInfo.validators)((0, _GuestPersonalInfo.removeExtraWhiteSpaces)(val), language.pwdId || _constant2.FIELDS.pwdId.label, language, fieldValidation, maxCharLengthAllowed || pwdIdMaxChar, _constant2.FIELDS.pwdId.name);
        },
        isRequired: (0, _GuestOfwInfo.returnIsRequired)(useDocRules, data),
        errorCallback: errorCallback,
        touched: (0, _GuestOfwInfo.isTouched)(props.touched[_constant2.FIELDS.pwdId.name], props.values[_constant2.FIELDS.isPwd.name], useDocRules, props.values[_constant2.FIELDS.pwdId.name]),
        triggerOnChange: true
      })))), !newVersion && props.values[_constant2.FIELDS.isPwd.name] === 'true' && /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.Container, null, /*#__PURE__*/_react.default.createElement(_CardInfo.default, {
        accessible: true,
        content: language.pwdNote || _constant2.TRANSLATION.pwdNote,
        hasHeader: true,
        icon: "DescriptionOutlinedIcon",
        iconPosition: "left",
        iconSize: "titleLarge",
        isMobile: isMobile,
        theme: theme,
        title: language.pwdNoteHeader || _constant2.TRANSLATION.pwdNoteHeader,
        titleFirst: true
      })))
    );
  })));
};
GuestPwdInfo.propTypes = _GuestPwdInfo.default.PropTypes;
GuestPwdInfo.defaultProps = _GuestPwdInfo.default.DefaultProps;
var _default = GuestPwdInfo;
exports.default = _default;